<template>
    <div class="chart-card">
        <div class="chart-card-hd" :class="{'no-border': !headerBorder}">
            <div class="chart-card-hd-title">
                <slot v-if="!icon" name="icon"></slot>
                <img v-else class="chart-card-hd-title-icon" :src="icon"/>
                <slot v-if="!title" name="title"/>
                <span class="chart-card-hd-title__text" v-else>{{title}}</span>
                <slot v-if="!explain" name="title"/>
                <span class="chart-card-hd-title__explain" v-else>{{explain}}</span>
            </div>
            <div class="chart-card-hd-extra">
                <slot name="extra"></slot>
            </div>
        </div>
        <div class="chart-card-bd">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'VChartCard',
    props: {
        title: {
            type: String
        },
        icon: {
            type: String
        },
        explain: {
            type: String
        },
        headerBorder: {
            type: Boolean,
            default: true
        }
    }
}
</script>
<style lang="less" scoped>
@title: rgba(0,0,0,.85);
@text:rgba(0,0,0,.45);
.chart-card {
    background: #fff;
    border-radius: 4px;
    margin-bottom: 10px;
    &-hd {
        border-bottom: 1px solid #e8e8e8;
        &.no-border {
            border-bottom: 0px;
        }
        padding: 6px 16px 6px 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &-title {
            font-size: 18px;
            color: @title;
            display: flex;
            align-items: center;
            &-icon{
                display: inline-block;
                width: 22px;
                height: 22px;
                margin-right: 6px;
                vertical-align: middle;
            }
            &__text {
                line-height: 1;
            }
            &__explain {
                font-size: 14px;
            }
        }
    }
    &-bd {
       padding: 24px 16px 0;
    }
}

</style>


// WEBPACK FOOTER //
// src/components/charts/chart-card.vue